import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../utils/api'
import { RootState } from '../../rootReducer'

interface Organization {
  id: number;
  name: string;
  code: string;
  dni: string;
  domain: string;
  picture: string | null;
  sourceOrganization: number;
  createdAt: number;
  updatedAt: number;
}

// Ejecuta el proceso de sincronización de los datos del central
export const getUserProfileOrganization = createAsyncThunk<Organization[], string>('attendanceReport/getUserProfileOrganization',
  async (userId: string, { rejectWithValue }) => {
  try {

    const token = localStorage.getItem('token')
    const headers = new Headers()
    headers.append('Authorization', `Bearer ${token}`)
    headers.append('Content-Type', 'application/json')

    const response = await fetch(`${api.baseURL}userprofileorganization?user=${userId}`, {
      method: 'GET',
      headers: headers
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json();
    return data.map((item: any) => item.organization as Organization);
  } catch (error) {
    return rejectWithValue(error)
  }
})
